// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__yIw79","campaignBoxWrapper":"styles_campaignBoxWrapper__LFF_A"};
module.exports.__checksum = "5441ef8a99b9"